import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Client, ClientHistory, ClientType } from 'src/app/api/models';
import { ClientsService } from 'src/app/api/services';
import { ClientPeerService } from '../../service/client-peer.service';

@Component({
  selector: 'app-client-history',
  templateUrl: './client-history.component.html',
  styleUrls: ['./client-history.component.scss']
})
export class ClientHistoryComponent implements OnInit, OnDestroy {
  private readonly ngDestroy$ = new Subject();

  visible = false;
  history$: Observable<ClientHistory[]>;
  columns: string[];

  client$: Observable<Client>;
  ClientType = ClientType;

  constructor(private clientPeerService: ClientPeerService,
    private clientsService: ClientsService) {
  }

  ngOnInit(): void {
    this.client$ = this.clientPeerService.get().pipe(
      takeUntil(this.ngDestroy$),
      tap(client => this.updateColumns(client.client_type))
    );
  }

  private updateColumns(clientType: ClientType): void {
    const baseColumns = ['modified_at', 'name', 'country'];
    if (clientType === ClientType.Company) {
      this.columns = [...baseColumns, 'business_id', 'credit_limit', 'credit_limit_updated_at', 'prepayment_register_checked_at', 'aaa_rating', 'aaa_rating_updated_at', 'lead_provider_id', 'lead_source_id', 'responsible_seller_id'];
    } else {
      this.columns = [...baseColumns, 'personal_id', 'invoicing_service_company_business_id'];
    }
  }

  showHistory(client: Client): void {
    this.history$ = this.clientsService.getClientHistory({id: client.id});
    this.visible = true;
  }

  ngOnDestroy() {
    this.ngDestroy$.next(undefined);
    this.ngDestroy$.complete();
  }
}
